import { createContext } from 'react';

export const FontColorContext = createContext<any>('darkslategray');